import React, { useState, useRef, useEffect } from 'react';

import { Button, Popover } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { Form } from '@unform/web';
import { isEmpty } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import * as Yup from 'yup';

import { Dialog } from '~/components';
import { Autocomplete, DateTime, Input } from '~/components/Form';
import { t } from '~/helpers';
import { GoogleMaps, Markers, MarkersRemove } from '~/hooks/GoogleMaps';
import api from '~/services/api';

import { Container, Mapa, Menu, Footer, Content, Empty } from './styles';

export default function OperacaoGeolocalizacao() {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);

  const [markers, setMarkers] = useState(null);
  const [polyline, setPolyline] = useState(null);

  const start = moment()
    .set({ hour: 0, minute: 0, second: 0 })
    .format('DD/MM/YYYY HH:mm:ss');
  const end = moment()
    .set({ hour: 23, minute: 59, second: 0 })
    .format('DD/MM/YYYY HH:mm:ss');

  const [initials, setInitials] = useState({
    datahorainicialgeolocalizacaocomboio: start,
    datahorafinalgeolocalizacaocomboio: end,
    distancia: 30,
    intervalo: 0,
  });

  const mapRef = useRef();
  const formRef = useRef();

  /**
   * serialize type geolocalization
   *
   * @param {Number} type
   */
  function handleDescriptionType(type) {
    switch (type) {
      case 1:
        return t('s.operacao.geolocalizacao.posicaocambio');
      case 2:
        return t('s.operacao.geolocalizacao.abastecimento');
      case 3:
        return t('s.operacao.geolocalizacao.transferencia');
      case 4:
        return t('s.operacao.geolocalizacao.vazaonaoautorizada');
      default:
        return 'ND';
    }
  }

  // reset zoom
  async function handleResetZoom() {
    const position = [...data].shift();

    if (position) {
      const {
        latitudegeolocalizacaocomboio,
        longitudegeolocalizacaocomboio,
      } = position;

      await mapRef.current.setCenter({
        lat: latitudegeolocalizacaocomboio,
        lng: longitudegeolocalizacaocomboio,
      });
      await mapRef.current.setZoom(12);
    }
  }

  async function handleSubmit(props) {
    await setLoading(true);
    await setData([]);

    try {
      const schema = Yup.object().shape({
        idposto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        datahorainicialgeolocalizacaocomboio: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        datahorafinalgeolocalizacaocomboio: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        // distancia: Yup.string()
        //   .min(0)
        //   .required(t('s.geral.validacao.campoobrigatorio')),
        // intervalo: Yup.string()
        //   .min(0)
        //   .required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(props, {
        abortEarly: false,
      });

      const response = await api.get('geolocalizacoescomboios', {
        params: {
          wherefield: [
            'idposto',
            'datahorainicialgeolocalizacaocomboio',
            'datahorafinalgeolocalizacaocomboio',
          ],
          valuewherefield: [
            props.idposto,
            props.datahorainicialgeolocalizacaocomboio,
            props.datahorafinalgeolocalizacaocomboio,
          ],
          typewherefield: ['IGUAL', 'MAIOR_IGUAL', 'MENOR_IGUAL'],
          // distancia: props.distancia,
          // intervalo: props.intervalo,
          orderfield: 'datahorageolocalizacaocomboio',
          pagesize: 99999,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });

      await setData(response.data.items);
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        formRef.current.setErrors(validationErrors);
      }
    } finally {
      await setLoading(false);
      await setInitials(props);
    }
  }

  async function handleGetWindow(marker) {
    const { type } = marker;

    if (type === 1) {
      return `
      <header>${t('s.operacao.geolocalizacao.posicaocambio')}</header>
      <ul>
      <li><strong>Data/Hora</strong> ${moment(marker.date).format(
        'DD/MM/YYYY HH:mm:ss'
      )}</li>
      </ul>
      `;
    }

    if (type === 2) {
      const response = await api.get(
        `movimentacoesabastecimentos/${marker.id}/${marker.posto}`
      );

      return `
      <header>${t(
        's.operacao.geolocalizacao.detalhesabastecimentocomboio'
      ).replace('%s', response.data.idmovimentacao)}</header>
      <ul>
      <li><strong>${t('s.operacao.geolocalizacao.frota')}</strong> ${
        response.data.idveiculo
      }</li>
      <li><strong>${t('s.operacao.geolocalizacao.empresa')}</strong> ${
        response.data.idempresaveiculo
      }</li>
      <li><strong>${t('s.operacao.geolocalizacao.datahora')}</strong> ${
        response.data.datahorafinalmovimentacao
      }</li>
      <li><strong>${t('s.operacao.geolocalizacao.volumeabastecido')}</strong> ${
        response.data.volumemovimentacao
      }</li>
      </ul>
      `;
    }

    if (type === 4) {
      const response = await api.get(
        `movimentacoesvazoesnaoautorizadas/${marker.id}/${marker.posto}`
      );

      return `
      <header>${t(
        's.operacao.geolocalizacao.detalhesabastecimentocomboio'
      ).replace('%s', response.data.idmovimentacao)}</header>
      <ul>
      <li><strong>${t('s.operacao.geolocalizacao.datahora')}</strong> ${
        response.data.datahorainicialmovimentacao
      }</li>
      <li><strong>${t('s.operacao.geolocalizacao.bico')}</strong> ${
        response.data.idbico
      }</li>
      <li><strong>${t('s.operacao.geolocalizacao.volume')}</strong> ${
        response.data.volumemovimentacao
      }</li>
      </ul>
      `;
    }

    return '';
  }

  useEffect(() => {
    if (!isEmpty(markers)) {
      MarkersRemove(markers, polyline);
    }

    const safeData = Array.isArray(data) ? data : [];

    const items = safeData
      .filter((marker) => marker && marker.latitudegeolocalizacaocomboio && marker.longitudegeolocalizacaocomboio)
      .map((marker, index) => ({
        id: marker.idmovimentacao ?? null,
        lat: Number(marker.latitudegeolocalizacaocomboio),
        lng: Number(marker.longitudegeolocalizacaocomboio),
        label: marker.rownum?.toString() ?? String(index + 1),
        type: marker.tipogeolocalizacaocomboio ?? '',
        date: marker.datahorageolocalizacaocomboio ?? null,
        posto: marker.idposto ?? null,
      }));

    if (items.length > 0) {
      const google = Markers(mapRef, items, true, handleGetWindow);

      setMarkers(google?.markers ?? []);
      setPolyline(google?.polyline ?? null);
    } else {
      setMarkers([]);
      setPolyline(null);
    }
  }, [data]);

  useEffect(() => {
    GoogleMaps(mapRef);
  }, []);

  return (
    <Dialog
      toggle={() => setOpen(false)}
      open={open}
      title={t('s.menu.operacao.geolocalizacao')}
    >
      <Container>
        <header>
          <Button
            variant="contained"
            endIcon={<ArrowDropDown />}
            onClick={(event) => setAnchorEl(event.currentTarget)}
          >
            {t('s.operacao.geolocalizacao.marcadores')}
          </Button>
          <Popover
            id={anchorEl ? 'simple-popover' : undefined}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            style={{ marginTop: '1rem' }}
            onEntered={() => formRef.current.setData(initials)}
          >
            <Menu>
              <Form
                ref={formRef}
                initialData={initials}
                onSubmit={handleSubmit}
              >
                <Autocomplete
                  name="idposto"
                  unique="idposto"
                  label="nomeposto"
                  title={t('s.operacao.geolocalizacao.comboio')}
                  url="comboios"
                />

                <DateTime
                  time
                  name="datahorainicialgeolocalizacaocomboio"
                  label={t('s.cadastro.contrato.datainicialcontrato')}
                />

                <DateTime
                  time
                  name="datahorafinalgeolocalizacaocomboio"
                  label={t('s.cadastro.contrato.datafinalcontrato')}
                />

                {/* <div className="form-group">
                  <Input
                    name="distancia"
                    label={t('s.operacao.geolocalizacao.distancia')}
                    type="number"
                  />

                  <Input
                    name="intervalo"
                    label={t('s.operacao.geolocalizacao.intervalo')}
                    type="number"
                  />
                </div> */}
              </Form>
              <Content>
                {(isEmpty(data) || loading) && (
                  <Empty>
                    {loading
                      ? 'Carregando...'
                      : t('s.operacao.geolocalizacao.semregistros')}
                  </Empty>
                )}

                {data.map((item) => (
                  <div
                    className="item"
                    key={item.rownum}
                    onClick={() =>
                      mapRef.current.setCenter({
                        lat: item.latitudegeolocalizacaocomboio,
                        lng: item.longitudegeolocalizacaocomboio,
                      })
                    }
                  >
                    <span>{item.rownum}</span>
                    <span>
                      {handleDescriptionType(item.tipogeolocalizacaocomboio)}
                    </span>
                    <span>
                      {moment(item.datahorageolocalizacaocomboio).format(
                        'DD/MM/YYYY HH:mm:ss'
                      )}
                    </span>
                  </div>
                ))}
              </Content>
              <Footer>
                <Button
                  variant="outlined"
                  color="secondary"
                  disabled={loading}
                  onClick={() => handleResetZoom()}
                >
                  {t('s.operacao.geolocalizacao.resetarzoom')}
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  disabled={loading}
                  onClick={() => formRef.current.submitForm()}
                >
                  {t('s.operacao.geolocalizacao.buscar')}
                </Button>
              </Footer>
            </Menu>
          </Popover>
        </header>
        <Mapa ref={mapRef} />
      </Container>
    </Dialog>
  );
}
